import React, { useState } from 'react';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import ButtonGroup from '../elements/ButtonGroup';
import Button from '../elements/Button';
import Image from '../elements/Image';
import Modal from '../elements/Modal';
const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

const Hero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {

  const [videoModalActive, setVideomodalactive] = useState(false);

  const openModal = (e) => {
    e.preventDefault();
    setVideomodalactive(true);
  }

  const closeModal = (e) => {
    e.preventDefault();
    setVideomodalactive(false);
  }   

  const outerClasses = classNames(
    'hero section center-content',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'hero-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  return (
    <section
      {...props}
      style={{marginTop:-50}}
      className={outerClasses}
    >
      <div>
        <div className={innerClasses}>
          <div className="hero-content">
            <div style={{display:"flex",flexDirection:"column"}}>
            <Image
                
                src={require('./../../assets/images/logo.png')}
               width={116}
               height={167}
               />
                 <h1 className="mt-0 mb-16 reveal-from-bottom" data-reveal-delay="200">
           <span className="text-color-primary">Atom</span>  For Reddit
            </h1>
            </div>
           
            <div className="container-xs">
              <p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="200">
              The latest client app  with essential features for browsing  Reddit
                </p>
              <div className="reveal-from-bottom" data-reveal-delay="200">
                <ButtonGroup>
                  <a href='https://play.google.com/store/apps/details?id=com.atom.reddit.reader' target="_blank">
                <Image
                src={require('./../../assets/images/googleplay.png')}
               width={200}
               height={77}
               />
                  </a>
                </ButtonGroup>
              </div>
            </div>
          </div>
          <div width={300} className="reveal-from-bottom " data-reveal-value="20px" data-reveal-delay="200">
         
              <Image
                className="has-shadow"
                src={require('./../../assets/images/cover.webp')}
                alt="Hero"
                width={1200}
                height={400} />
          </div>
        
        </div>
      </div>
    </section>
  );
}

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

export default Hero;